import React, { Component } from 'react'
import { Pagination, PaginationItem, PaginationLink} from 'reactstrap';
import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'


interface IEsaedroPagerProps {
  currentPage:number;
  totalPages:number;
  onClick(page: number): void;
}


export default class EsaedroPager extends Component<IEsaedroPagerProps, any> {
  
  constructor(props: IEsaedroPagerProps){
      super(props);
  }

  render() {

    let pagenumbers = [
      this.props.currentPage<5?1:this.props.currentPage-2,
      this.props.currentPage<=5?2:this.props.currentPage-1,
      this.props.currentPage<5?3:this.props.currentPage,
      this.props.currentPage<5?4:this.props.currentPage+1,
      this.props.currentPage<5?5:this.props.currentPage+2
    ]
    let pager = this.props.totalPages == 1
    ? ''
    : <Pagination size="sm">
          <PaginationItem disabled={this.props.currentPage <= 1}>
              <PaginationLink
                  previous
                  onClick={() => this.props.onClick(1)}
              />
          </PaginationItem>
          <PaginationItem disabled={this.props.currentPage <= 1}>
              <PaginationLink
                  previous
                  onClick={() => this.props.onClick(this.props.currentPage-1)}
              />
          </PaginationItem>
          {pagenumbers[0]<=this.props.totalPages
              ?<PaginationItem active={pagenumbers[0]==this.props.currentPage}>
                  <PaginationLink  onClick={() => this.props.onClick(pagenumbers[0])}>
                      {pagenumbers[0]}
                  </PaginationLink>
              </PaginationItem>
              : undefined
          }
          {pagenumbers[1]<=this.props.totalPages
              ?<PaginationItem active={pagenumbers[1]==this.props.currentPage}>
                  <PaginationLink  onClick={() => this.props.onClick(pagenumbers[1])}>
                      {pagenumbers[1]}
                  </PaginationLink>
              </PaginationItem>
              : undefined
          }
          {pagenumbers[2]<=this.props.totalPages
              ?
              <PaginationItem active={pagenumbers[2]==this.props.currentPage}>
                  <PaginationLink  onClick={() => this.props.onClick(pagenumbers[2])}>
                      {pagenumbers[2]}
                  </PaginationLink>
              </PaginationItem>
              : undefined
          }
          {pagenumbers[3]<=this.props.totalPages
                  ?
              <PaginationItem active={pagenumbers[3]==this.props.currentPage}>
                  <PaginationLink  onClick={() => this.props.onClick(pagenumbers[3])}>
                      {pagenumbers[3]}
                  </PaginationLink>
              </PaginationItem>
              : undefined
          }
          {pagenumbers[4]<=this.props.totalPages
              ?
              <PaginationItem active={pagenumbers[4]==this.props.currentPage}>
                  <PaginationLink  onClick={() => this.props.onClick(pagenumbers[4])}>
                      {pagenumbers[4]}
                  </PaginationLink>
              </PaginationItem>
              : undefined
          }
          <PaginationItem disabled={this.props.currentPage==this.props.totalPages}>
              <PaginationLink 
                  next 
                  onClick={() => this.props.onClick(this.props.currentPage+1)} 
              />
          </PaginationItem>
          <PaginationItem disabled={this.props.currentPage == this.props.totalPages}>
              <PaginationLink
                  next
                  onClick={() => this.props.onClick(this.props.totalPages)}
              />
          </PaginationItem>
      </Pagination>

    return pager
  }
}
  